<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('purchase.archive_order')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class='form-inline mb-4 justify-content-between'>
        <div class="d-flex flex-wrap align-items-center">
          <div class="form-group mr-2">
            <router-link class='btn btn-primary' to='new-purchases'>{{translations('common.addition')}}</router-link>
          </div>
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="master_partners.find(m => m.id === partner_id) || ''"
              :options="master_partners"
              label="name"
              :placeholder="translations('purchase.payment_destination')"
              id="partner_id"
              @input="changedPartner">
            </v-select>
          </div>
          <div class="form-group mr-3 d-flex flex-wrap">
            <span class="mr-1">{{translations('common.period')}}</span>
            <!--          <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateField = dateFrom">-->
            <input v-model="dateFrom" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
            <!--          <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateField = dateTo">-->
            <input v-model="dateTo" type="date" class="form-control">
          </div>
          <div class="form-group">
            <div class="form-check">
              <input v-model="isShowArrived" class="form-check-input" type="checkbox" value="" id="checkShowArrived">
              <label class="form-check-label" for="checkShowArrived">
                {{translations('purchase.past_orders')}}
              </label>
            </div>
          </div>
          <div class="form-group ml-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
          <div class="form-group ml-2">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-group" style="margin: 1px 0 0 0">
          <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-1500 table-clickable table-no-margin"
          item-key="name"
          :headers="[
            { text: 'No', value: '', sortable: false },
            { text: this.translations('purchase.estimation_status'), value: 'purchase_status' },
            { text: this.translations('purchase.order_date'), value: 'purchase_at' },
            { text: this.translations('purchase.name'), value: 'name' },
            { text: this.translations('purchase.client_order_number'), value: 'purchase_number' },
            { text: this.translations('purchase.payment_destination'), value: 'kaishu_partner_name' },
            { text: this.translations('purchase.jan_code'), value: 'jan_code' },
            { text: this.translations('purchase.model'), value: 'model' },
            { text: this.translations('purchase.count'), value: 'quantity' },
            { text: this.translations('purchase.unit_price'), value: 'unit_price' },
            { text: this.translations('purchase.total_amount'), value: 'total_amount' },
            { text: this.translations('purchase.stock_date'), value: 'arrival_scheduled_at' },
            { text: this.translations('purchase.warehouse'), value: 'kaishu_warehouse_name' },
            { text: this.translations('purchase.remarks'), value: 'memo' }
          ]"
          :items="purchases"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for="(purchase, i) in items" :key='i' data-href="" @click="openSinglePurchases(purchase)">
                  <td>{{i + 1}}</td>
                  <td>
                    <span class="badge" :class="getStatusClass(purchase.purchase_status)">
                      {{ getStatusLabel(purchase.purchase_status) }}
                    </span>
                  </td>
                  <td>{{ $invoiceTools.formatDate(purchase.purchase_at) }}</td>
                  <td>{{ purchase.name }}</td>
                  <td>{{ purchase.purchase_number }}</td>
                  <td>{{ purchase.kaishu_partner_name }}</td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in purchase.details" :key="i">{{detail.jan_code || '-'}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in purchase.details" :key="i">{{detail.model || '-'}}</li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in purchase.details" :key="i">{{detail.quantity.toLocaleString()}}</li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in purchase.details" :key="i">{{ detail.unit_price.toLocaleString() }}</li>
                    </ul>
                  </td>
                  <td class="right">{{ purchase.total_amount.toLocaleString() }}</td>
                  <td>{{ $invoiceTools.formatDate(purchase.arrival_scheduled_at) }}</td>
                  <td>{{ purchase.kaishu_warehouse_name }}</td>
                  <td>{{ purchase.memo }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
    <ArchivePurchaseModal/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ArchivePurchaseModal from '@/components/purchase/ArchivePurchaseModal'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchivePurchase',
  props: {},
  components: {
    VueElementLoading,
    ArchivePurchaseModal
  },
  data () {
    return {
      dtSearch: '',
      isSearching: false,
      isShowArrived: false,
      partner_id: 0,
      dateFrom: '',
      dateTo: '',
      purchases: [],
      isEmpty: false,
      isEmptyMsg: '',
      // tempDateField: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      displayAll: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_partners () {
      return this.$store.getters['Master/getPayTo']
    }
  },
  watch: {
    // partner_id () {
    //   this.initList()
    // },
    page () {
      this.getFilterList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountPurchase')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created () {
    this.$store.dispatch('Master/checkPayTo')
    const storedFilter = this.$storage.get('ArchivePurchaseFilter')
    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.partner_id = storedFilter.partner_id
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.isShowArrived = storedFilter.show_arrived
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getStatusClass (status) {
      if (Number(status) === 1) {
        return 'badge-light'
      } else if (Number(status) === 2) {
        return 'badge-success'
      } else if (Number(status) === 3) {
        return 'badge-warning'
      }
      return 'badge-warning'
    },

    getStatusLabel (status) {
      if (Number(status) === 1) {
        return this.translations('purchase.not_in_stock')
      } else if (Number(status) === 2) {
        return this.translations('purchase.already_in_stock')
      } else if (Number(status) === 3) {
        return this.translations('purchase.partially_in_stock')
      }
      return this.translations('purchase.not_applicable')
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    // changeSearch (e) {
    //   this.$storage.set('ArchivePurchase:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterList()
      }
    },

    getFilterList (field, val) {
      if (this.isSearching) {
        return
      }

      if (this.displayAll) {
        this.$storage.set('purchase_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      const params = {
        partner_id: this.partner_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        show_arrived: this.isShowArrived,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }

      this.$storage.set('ArchivePurchaseFilter', params)
      console.log('ArchivePurchase:getFilterList: ', params)

      this.$http.post(this.$api_url.purchase_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.purchases = result.list
          localStorage.setItem('visitCountPurchase', this.purchases.length)
          this.totalCount = Number(result.total_count)
        } else {
          this.purchases = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchivePurchase:getFilterList:catch(error): ', error)
        this.$toastr.error(this.translations('purchase.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    openSinglePurchases (purchase) {
      this.$router.push({ name: 'single-purchases', query: { purchase_id: purchase.id } })
    },

    changedPartner (event) {
      if (!event) {
        this.partner_id = 0
        return
      }
      this.partner_id = event.id
    },

    submitSearch () {
      this.initList()
    },

    exportCsv (field, val) {
      if (this.isSearching) {
        return
      }

      this.isSearching = true
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      const params = {
        partner_id: this.partner_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        show_arrived: this.isShowArrived,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }

      this.$storage.set('ArchivePurchaseFilter', params)
      console.log('ArchivePurchase:exportCsv: ', params)

      this.$http.post(this.$api_url.purchase_csv, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.saveCsv_(result.list)
        } else {
          this.purchases = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchivePurchase:getFilterList:catch(error): ', error)
        this.$toastr.error(this.translations('purchase.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        const estimationStatus = this.getStatusLabel(item.purchase_status)
        item.details.forEach(detail => {
          data.push([
            estimationStatus,
            item.purchase_at,
            item.name,
            item.purchase_number,
            item.kaishu_partner_name,
            detail.jan_code,
            detail.model,
            detail.quantity,
            detail.unit_price,
            item.total_amount,
            item.arrival_scheduled_at,
            item.kaishu_warehouse_name,
            item.memo
          ])
        })
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('purchase.estimation_status'),
          this.translations('purchase.order_date'),
          this.translations('purchase.name'),
          this.translations('purchase.client_order_number'),
          this.translations('purchase.payment_destination'),
          this.translations('purchase.jan_code'),
          this.translations('purchase.model'),
          this.translations('purchase.count'),
          this.translations('purchase.unit_price'),
          this.translations('purchase.total_amount'),
          this.translations('purchase.stock_date'),
          this.translations('purchase.warehouse'),
          this.translations('purchase.remarks')
        ],
        data: data
      })
      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('purchase.purchase_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-purchases_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
